import {
  Component, ElementRef, HostListener,
  ViewChild
} from '@angular/core';
import {
  Router,
} from '@angular/router';
import { DialogService, LegacyDialogConfig } from '@psei/ng/dialog';
import { DrawerService } from '@psei/ng/drawer';
import { FormChangeService } from 'projects/ppb-shared-library/src/lib/services/form-change.service';

/**
 * Uses ng-zone to omit change detection for performance.
 */
@Component({
  selector: 'ppb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @ViewChild('spinnerElement', { static: true })
  spinnerElement: ElementRef;
  private dialog: LegacyDialogConfig;

  constructor(
    private router: Router,
    private formChangeService: FormChangeService,
    private drawerService: DrawerService,
    private dialogBoxService: DialogService) {
    this.dialogBoxService.legacy.current$.subscribe((currentDialog: LegacyDialogConfig) => {
      this.dialog = currentDialog;
    });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(): void {
    if (this.dialog) {
      this.dialogBoxService.legacy.closeCurrent();
    } else {
      if (!this.formChangeService.isDrawerOpen) {
        this.drawerService.active?.close();
      }
    }
  }

  @HostListener('document:copy', ['$event'])
  onCopy($event: ClipboardEvent): void {
    $event.preventDefault();
    const selectedText = document.getSelection().toString().trim();
    $event.clipboardData.setData('text/plain', selectedText);
  }

}
